import {iFrameState} from "../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../blink-sdk/Constants";
import {Messages} from "../../../Messages";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw";
import {BasePanelPage} from "../../PanelPage";


@autoredraw(iFrameState)
export class FunctionalityNotEnabledPanel extends BasePanelPage {
    getMessage() {
        switch(iFrameState.panelType) {
            case PANEL_TYPE.newsletter:
                return Messages.functionalityNotEnabledNewsletters;
            case PANEL_TYPE.giftSubscription:
            case PANEL_TYPE.subscribe:
                return Messages.functionalityNotEnabledSubscriptions;
            case PANEL_TYPE.donation:
            case PANEL_TYPE.donationPage:
                return Messages.functionalityNotEnabledDonations;
            case PANEL_TYPE.shop:
                return Messages.functionalityNotEnabledShop;
            default:
                return Messages.functionalityNotEnabledGeneric;
        }
    }

    render() {
        return <MessageElement message={this.getMessage()} args={[iFrameMerchantService.getMerchant().name]}/>;
    }
}
